<template>
  <aside v-if="eligible && $route.path !== '/admin/account/sign-in'" class="mgc-system self-link-prompt" aria-label="University sign-in">
    <div v-if="!dismissed" class="mgc-card self-link-card">
      <div class="self-link-copy">
        <h2 class="mgc-subheading">University sign-in is now available</h2>
        <p class="mgc-body">Use your university account to sign in to MGC. Your access and data stay the same.</p>
      </div>
      <div class="self-link-actions">
        <router-link class="mgc-button" to="/admin/account/sign-in">Connect account</router-link>
        <button type="button" class="mgc-link self-link-later" @click="dismiss">Later</button>
      </div>
    </div>
    <div v-else class="self-link-dismissed">
      <router-link ref="settings" class="mgc-link self-link-settings" to="/admin/account/sign-in">University sign-in settings</router-link>
    </div>
  </aside>
</template>
<script>
import Auth from '../../api/auth';
import '../../styles/mgc-system.css';
import { sharedSsoAvailable } from '../../api/sharedSso';
import { linkingStatus } from '../../api/selfServiceLink';
export default {
  data: () => ({ eligible: false, dismissed: false, accountKey: '' }),
  mounted() { this.load(); },
  watch: { $route() { this.load(); } },
  methods: {
    async load() {
      const actor = Auth.getPayload();
      const key = `${actor.tenant}:${actor.sub}`;
      if (this.accountKey === key) return;
      this.accountKey = key;
      this.eligible = false;
      if (!sharedSsoAvailable() || !actor.sub) return;
      try {
        this.dismissed = sessionStorage.getItem(`self-link-later:${key}`) === 'true';
        const status = await linkingStatus();
        if (this.accountKey === key) this.eligible = status.eligible === true;
      } catch (_) { /* Optional onboarding must not interrupt normal product access. */ }
    },
    dismiss() {
      this.dismissed = true;
      this.$nextTick(() => this.$refs.settings.$el.focus());
      try { sessionStorage.setItem(`self-link-later:${this.accountKey}`, 'true'); } catch (_) { /* Keep this visit usable if storage is blocked. */ }
    },
  },
};
</script>
<style scoped>
.self-link-prompt { max-width: 768px; margin: 24px auto; }
.self-link-card { display: grid; grid-template-columns: minmax(0, 1fr) auto; align-items: center; gap: 24px; }
.self-link-copy .mgc-subheading { margin-bottom: 8px; }
.self-link-copy .mgc-body { margin-bottom: 0; }
.self-link-actions { display: grid; justify-items: stretch; gap: 4px; }
.self-link-later, .self-link-settings { display: inline-flex; align-items: center; justify-content: center; min-height: var(--mgc-control-height); padding: 10px 12px; font: inherit; font-size: 14px; }
.self-link-dismissed { display: flex; justify-content: flex-end; }
@media (max-width: 640px) {
  .self-link-card { grid-template-columns: minmax(0, 1fr); gap: 20px; }
  .self-link-actions { grid-template-columns: minmax(0, 1fr) auto; align-items: center; gap: 12px; }
}
</style>
